import { ManagerialAccountingQuarter } from '@/common/graphql';

// The 4 quarters in calendar order, indexable by quarter ordinal (0=Q1..3=Q4).
export const QUARTERS_IN_ORDER: Array<ManagerialAccountingQuarter> = [
  ManagerialAccountingQuarter.Q1,
  ManagerialAccountingQuarter.Q2,
  ManagerialAccountingQuarter.Q3,
  ManagerialAccountingQuarter.Q4,
];

// Maps a 0-indexed JS Date month (0=Jan..11=Dec) to its quarter ordinal (0=Q1..3=Q4).
export const quarterIndexForMonth = (month: number): number => Math.floor(month / 3);

// Maps a 0-indexed JS Date month (0=Jan..11=Dec) to its calendar quarter.
export const quarterForMonth = (month: number): ManagerialAccountingQuarter =>
  QUARTERS_IN_ORDER[quarterIndexForMonth(month)];

// Ordinal (0=Q1..3=Q4) for each quarter, derived from QUARTERS_IN_ORDER.
const QUARTER_ORDINAL: Record<ManagerialAccountingQuarter, number> = Object.fromEntries(
  QUARTERS_IN_ORDER.map((quarter, ordinal) => [quarter, ordinal]),
) as Record<ManagerialAccountingQuarter, number>;

// Comparable ordinal for a (year, quarter) period — later periods always sort higher, used to
// find the latest/taken periods and to compare "from"/"to" range endpoints across years.
export const periodOrd = (year: string | number, quarter: string) =>
  Number(year) * 4 + (QUARTER_ORDINAL[quarter as ManagerialAccountingQuarter] ?? 0);

const QUARTER_LABELS: Record<ManagerialAccountingQuarter, string> = {
  [ManagerialAccountingQuarter.Q1]: 'Q1 (Jan - Mar)',
  [ManagerialAccountingQuarter.Q2]: 'Q2 (Apr - Jun)',
  [ManagerialAccountingQuarter.Q3]: 'Q3 (Jul - Sep)',
  [ManagerialAccountingQuarter.Q4]: 'Q4 (Oct - Dec)',
};

export interface QuarterOption {
  value: ManagerialAccountingQuarter;
  label: string;
}

// Shared {value, label} options for quarter selects, in calendar order.
export const QUARTER_OPTIONS: Array<QuarterOption> = QUARTERS_IN_ORDER.map(quarter => ({
  value: quarter,
  label: QUARTER_LABELS[quarter],
}));
